import axios from 'axios';
import { INotaBlog } from '@/shared/model/nota-blog.model';

const baseApiUrl = 'api/nota-blogs';

export default class NotaBlogService {
  public findActivas(): Promise<INotaBlog[]> {
    return new Promise<INotaBlog[]>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/activas`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public findAll(): Promise<INotaBlog[]> {
    return new Promise<INotaBlog[]>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public find(id: number): Promise<INotaBlog> {
    return new Promise<INotaBlog>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public create(entity: INotaBlog): Promise<INotaBlog> {
    return new Promise<INotaBlog>((resolve, reject) => {
      axios
        .post(baseApiUrl, entity)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public update(entity: INotaBlog): Promise<INotaBlog> {
    return new Promise<INotaBlog>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => resolve(res.data))
        .catch(err => reject(err));
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }
}
